import { Row } from '@components/Layout/Row';
import { useMediaQuery } from '@hooks/useMediaQuery';
import Paper from '@material-ui/core/Paper';
import { call } from '@packages/functions';
import React, { useContext } from 'react';
import CategorySelector from '../../Categories/components/CategorySelector';
import { InstantQuoteContext } from './InstantQuoteStepper';
import IQHeadline from './IQHeadline';

/**
 * @author: Dumitrana Alinus <alin.designstudio@gmail.com>
 * @class: Category
 * @date:  30.08.2019
 * @time:  22:53
 */
export default function Category({ onChange }: any) {
    const { instantQuote, dispatch } = useContext<any>(InstantQuoteContext);

    const isMobile = useMediaQuery('mobile');

    const handleOnSelect = (id, categories) => {
        const category = categories.filter((c) => c.id === id)[0];

        dispatch({ type: 'setCategory', payload: id });
        dispatch({ type: 'setCategoryObject', payload: category });
        dispatch({ type: 'setPackage', payload: null });
        dispatch({ type: 'setOptions', payload: [] });

        dispatch({
            type: 'setOrder',
            payload: {
                ...instantQuote.order,

                items: [],
                category_id: id,

                customer: {
                    ...instantQuote.order.customer,
                    category_id: id,
                },
            },
        });

        dispatch({ type: 'recalculateIsDone', payload: [] });

        dispatch({
            type: 'updateSummary',
            payload: {
                package_id: null,
                package: null,
                skus_ids: [],
                skus: [],
            },
        });
        call(onChange, 1);
    };

    return (
        <>
            <IQHeadline
                headTitle={'Instant Free Quote'}
                title={'1. Select Category'}
                text={'Please select the category or type of apparel you wish to order.'}
            />

            <Row component={Paper} elevation={0} align={'center'} padding={isMobile ? 6 : 14}>
                <CategorySelector auto onSelect={handleOnSelect} selectedId={instantQuote.category_id as any} />
            </Row>
        </>
    );
}
